import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import TerminList from '../../../module/Admin/Termin/List';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';
import useFilterFromUrl from '../hooks/useFilterFromUrl';
import useTezaurusDetail from '../../../hooks/useTezaurusDetail';

const AdminTerminListPage = (): ReactElement => {
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();
  const {
    tezaurus,
    tezaurusStatus,
  } = useTezaurusDetail(tezaurusUuid, tezaurusUuid !== null);
  const { pathname } = useLocation();

  const {
    initialFilter,
    initialFilterLoading,
    initialFilterFinished,
  } = useFilterFromUrl();

  useEffect(() => {
    if (!tezaurusStatus?.loading) {
      setTitle(getTitle());
    }
  }, [tezaurusStatus?.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.tezaurus.admin.list,
          heading: 'Administrácia tezaurov',
        },
        {
          to: pathname,
          heading: tezaurus?.nazov || 'Zoznam termínov',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={tezaurusStatus?.loading}>
        <SecuredPage
          allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS, UserRoleEnum.REDAKTOR_TEZAURUS]}
          requestStatus={tezaurusStatus?.responseCode}
        >
          {tezaurus && (
          <>
            <>
              <PageHeadingWithBackButton
                heading={tezaurus.nazov}
                backLinkText="Späť na zoznam tezaurov"
                backLinkRoute={routes.tezaurus.admin.list}
                headingCaption="Administrácia tezaurov"
              />
              <Loader loading={initialFilterLoading}>
                {initialFilter && initialFilterFinished && (
                  <TerminList
                    initialFilter={initialFilter}
                  />
                )}
              </Loader>
            </>
          </>
          )}
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default AdminTerminListPage;
